<div class="flex flex-row flex-wrap pl-2 py-3 border-b border-gray-1">
  <div (click)="onExitDetailClick()" class="text-primary cursor-pointer">Reality Capture</div>
  <div class="ml-1">> {{ translations.breadcrumbs.details.text }}</div>
</div>

<div
  modus-tooltip="{{ currentModelName() }}"
  class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-primary pl-2 pt-2 pb-2 pr-1 font-semibold"
  data-cy="scan-3d-detail-title"
>
  {{ currentModelName() }}
</div>

<mat-tab-group
  preserveContent="true"
  class="mds-small h-full overflow-hidden"
  disableRipple
  (selectedTabChange)="onSelectedTabChange($event)"
>
  <mat-tab label="{{ translations.properties.text }}" labelClass="!p-0">
    <div class="h-full overflow-y-scroll border-t border-gray-1 p-4">
      <sd-properties
        [scandataModel]="currentModel()"
        [readonly]="true"
        [showTags]="true"
        [showName]="false"
      ></sd-properties>
    </div>
  </mat-tab>
  <mat-tab label="{{ translations.styling.text }}" labelClass="!p-0">
    <div class="h-full border-t border-gray-1 p-4">
      <sd-scan-3d-styling
        class="h-full"
        [elevationPicking]="elevationPicking()"
        [scandataModel]="currentModel()"
        [scan3dStyle]="scan3dStyle()"
        [scan3dStyleUom]="scan3dStyleUom()"
        (styleChange)="onStyleChange($event)"
        (elevationPickingChange)="onElevationPickingChange($event)"
      ></sd-scan-3d-styling>
    </div>
  </mat-tab>
</mat-tab-group>
